import { useEffect, useState } from 'react';
import { IoDownloadOutline } from 'react-icons/io5';

export default function InstallApp() {
  const [prompt, setPrompt] = useState(window.readTheWordInstallPrompt || null);
  const [installed, setInstalled] = useState(window.matchMedia('(display-mode: standalone)').matches || navigator.standalone === true);
  useEffect(() => {
    const available = event => { event.preventDefault(); setPrompt(event); };
    const complete = () => { setInstalled(true); setPrompt(null); };
    window.addEventListener('beforeinstallprompt', available);
    window.addEventListener('appinstalled', complete);
    return () => {
      window.removeEventListener('beforeinstallprompt', available);
      window.removeEventListener('appinstalled', complete);
    };
  }, []);
  const install = async () => {
    if (!prompt) return;
    await prompt.prompt();
    await prompt.userChoice;
    window.readTheWordInstallPrompt = null;
    setPrompt(null);
  };
  return <section className="install-app" aria-labelledby="install-title">
    <IoDownloadOutline size={24} aria-hidden="true" />
    <div><h2 id="install-title">{installed ? 'ReadTheWord is installed' : 'Keep your reading close'}</h2>
      <p>{installed ? 'Open ReadTheWord from your home screen whenever you’re ready to read.' : 'Add ReadTheWord to your home screen for a dedicated app experience.'}</p>
      {!installed && !prompt && <p className="install-help">On iPhone or iPad, open this site in Safari, tap Share, then Add to Home Screen. In other browsers, look for Install app or Add to Home Screen in the browser menu.</p>}
    </div>
    {!installed && prompt && <button type="button" className="season-button" onClick={install}>Install app</button>}
  </section>;
}
